var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
//component
import EhpPostCode from "../../common/postcode/EhpPostCode";
/**
 * @brief EHP 사업장 전기실 관리 - 상세 사업장 수정 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
function SubZoneUpdate(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentPopWin = props.setPopWin;
    const setParentCurTree = props.setCurTree;
    const setParentWorkMode = props.setWorkMode;
    //
    const [errorList, setErrorList] = useState([]);
    //const [subZoneName, setSubZoneName] = useState("");
    //const [managerInfo, setManagerInfo] = useState({ "id": "", "name": "", "telNo": "" });
    //const [address, setAddress] = useState("");
    //const [memo, setMemo] = useState("");
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    const [subZoneInfo, setSubZoneInfo] = useState({
        "isontree": true,
        "sort": 0,
        "approval": 0,
        "subZoneId": "",
        "subZoneName": "",
        "address": "",
        "memo": "",
        "itemCount": 0,
    });
    function callbackSetSubZoneInfoMemo(val) {
        setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { memo: val }));
    }
    function callbackSetSubZoneInfoAddress(val) {
        clog("callbackSetSubZoneInfoAddress : " + val);
        setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { address: val }));
    }
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    useEffect(() => {
        setParentPopWin("pop-postcode", React.createElement(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetSubZoneInfoAddress }));
    });
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
    }
    useEffect(() => {
        setParentPopWin("pop-area-right-page-info", React.createElement(MobileSubZoneUpdate, { curTree: curTree, subZoneInfo: subZoneInfo, setSubZoneInfo: setSubZoneInfo, callbackSetSubZoneInfoMemo: callbackSetSubZoneInfoMemo, errorList: errorList, onClickDoUpdateSubZone: onClickDoUpdateSubZone, onClickDoCancelSubZone: onClickDoCancelSubZone, onClickPostCode: onClickPostCode }));
    });
    const { data: retSubZone, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/zone/subzone/detail`,
        appQuery: { subZoneId: curTree.subZone.subZoneId },
        userToken: userInfo.loginInfo.token,
        watch: curTree.subZone.subZoneId + curTree.reload
    });
    useEffect(() => {
        if (retSubZone) {
            if (retSubZone.codeNum == CONST.API_200) {
                //clog("IN SUBZONE DETAIL : RES : " + JSON.stringify(retSubZone.body));        
                React.createElement(MobileSubZoneUpdate, { curTree: curTree, subZoneInfo: retSubZone.body, setSubZoneInfo: setSubZoneInfo, callbackSetSubZoneInfoMemo: callbackSetSubZoneInfoMemo, errorList: errorList, onClickDoUpdateSubZone: onClickDoUpdateSubZone, onClickDoCancelSubZone: onClickDoCancelSubZone, onClickPostCode: onClickPostCode });
                setSubZoneInfo(retSubZone.body);
            }
        }
    }, [curTree, retSubZone]);
    function onClickDoUpdateSubZone(e) {
        return __awaiter(this, void 0, void 0, function* () {
            //alert("상세사업장 수정 API 대기중.....");    
            //return;
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "PUT",
                "appPath": `/api/v2/product/company/zone/subzone/${subZoneInfo.subZoneId}`,
                appQuery: {
                    //"zoneId": curTree.zone.zoneId,
                    //"subZoneId": subZoneInfo.subZoneId,
                    "subZoneName": subZoneInfo.subZoneName,
                    //"inCharge": managerInfo.name,
                    //"contact": managerInfo.telNo,
                    "address": subZoneInfo.address,
                    "memo": subZoneInfo.memo
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN SUBZONE-UPDATE: onClickDoUpdateSubZone : " + JSON.stringify(data.body));
                    setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": data.body.subZoneId, "subZoneName": data.body.subZoneName } }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle
                    setErrorList(data.body.errorList);
                }
            }
            //return data;
        });
    }
    function onClickDoCancelSubZone(e, subZone) {
        setParentCurTree("SUBZONE", Object.assign(Object.assign({}, curTree), { subZone: { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName } }));
        setParentWorkMode("READ");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__right", ref: mobileRef },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC218\uC815")),
            React.createElement("div", { className: "area__right_content workplace__info info__input" },
                React.createElement("div", { className: "content__info h-auto" },
                    React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "subZoneName")).length > 0) ? "input-error" : "", value: subZoneInfo.subZoneName, onChange: (e) => setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { subZoneName: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "subZoneName")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "box__search" },
                                    React.createElement("input", { type: "text", placeholder: "\uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: subZoneInfo.address, 
                                        //onChange={(e)=>setSubZoneInfo({...subZoneInfo, address : e.target.value})}
                                        disabled: true }),
                                    React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) },
                                        React.createElement("span", { className: "hide" }, "\uC870\uD68C"))),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "address")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: subZoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetSubZoneInfoMemo), onChange: (e) => setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { memo: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "bg-gray", onClick: (e) => onClickDoCancelSubZone(e, subZoneInfo) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateSubZone(e) },
                        React.createElement("span", null, "\uC800\uC7A5")))))));
}
;
export default SubZoneUpdate;
function MobileSubZoneUpdate(props) {
    const curTree = props.curTree;
    const subZoneInfo = props.subZoneInfo;
    const setSubZoneInfo = props.setSubZoneInfo;
    const callbackSetSubZoneInfoMemo = props.callbackSetSubZoneInfoMemo;
    const errorList = props.errorList;
    const onClickDoUpdateSubZone = props.onClickDoUpdateSubZone;
    const onClickDoCancelSubZone = props.onClickDoCancelSubZone;
    const onClickPostCode = props.onClickPostCode;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, curTree.company.companyName),
                React.createElement("li", null, curTree.zone.zoneName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null, "\uC0C1\uC138 \uC0AC\uC5C5\uC7A5 \uC218\uC815")),
            React.createElement("div", { className: "area__right_content workplace__info info__input" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00 \uC815\uBCF4 \uC785\uB825"),
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", id: "inp1", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "subZoneName")).length > 0) ? "input-error" : "", value: subZoneInfo.subZoneName, onChange: (e) => setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { subZoneName: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "subZoneName")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "box__search" },
                                    React.createElement("input", { type: "text", placeholder: "\uC8FC\uC18C\uB97C \uC785\uB825\uD558\uC138\uC694", className: (errorList.filter(err => (err.field === "address")).length > 0) ? "input-error" : "", value: subZoneInfo.address, 
                                        //onChange={(e)=>setSubZoneInfo({...subZoneInfo, address : e.target.value})}
                                        disabled: true }),
                                    React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e) },
                                        React.createElement("span", { className: "hide" }, "\uC870\uD68C"))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { placeholder: "\uBA54\uBAA8\uB97C \uC785\uB825\uD558\uC138\uC694.", className: (errorList.filter(err => (err.field === "memo")).length > 0) ? "input-error" : "", value: subZoneInfo.memo, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 120), onKeyUp: (e) => CUTIL.afterHandleComment(e, 120, callbackSetSubZoneInfoMemo), onChange: (e) => setSubZoneInfo(Object.assign(Object.assign({}, subZoneInfo), { memo: e.target.value })) }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "memo")).map((err) => err.msg)))))),
                React.createElement("div", { className: "btn__wrap" },
                    React.createElement("button", { type: "button", className: "bg-gray btn-cancel", onClick: (e) => onClickDoCancelSubZone(e, subZoneInfo) },
                        React.createElement("span", null, "\uCDE8\uC18C")),
                    React.createElement("button", { type: "button", onClick: (e) => onClickDoUpdateSubZone(e) },
                        React.createElement("span", null, "\uC800\uC7A5")))))));
}
